exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Backdrop_Backdrop_3JyJ9 {\n    width: 100%;\n    height: 100%;\n    position: fixed;\n    z-index: 100;\n    left: 0;\n    top: 0;\n    background-color: rgba(0,0,0, 0.5);\n}", ""]);

// Exports
exports.locals = {
	"Backdrop": "Backdrop_Backdrop_3JyJ9"
};